import React from 'react'
import "./index.css"
import Logo from "./Logo.js";
import Home from './pages/Home';
import Contact from './pages/Contact';
import About from './pages/About';
import Nav from './Nav.js';
import Footer from './components/Footer.js';
import Projects from './projects/Projects';
import Project from './projects/Project';
import { HashRouter as Brouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Brouter>
      <div className='App'>
        <header className="header">
          <div className="header-inner">
            <Logo />
            <Nav />
          </div>
        </header>
        <main>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/about' element={<About />} />
            <Route path='/projects' element={<Projects />} />
            <Route path='/projects/:id' element={<Project />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Brouter>
  );
}

export default App;
